import { Link } from '@sortlist-frontend/design-system';

import type { RankingPromisingAgency } from '../../types';
import { agencyProfilePath } from '../../utils/agencyProfilePath';
import { AgencyLogo } from '../AgencyLogo';
import { RankingCard } from '../RankingCard';
import { RatingStat } from '../RatingStat';

interface PromisingAgencyCardProps {
  agency: RankingPromisingAgency;
  locale: string;
}

export const PromisingAgencyCard = (props: PromisingAgencyCardProps) => {
  const { agency, locale } = props;

  return (
    <RankingCard className="flex items-center gap-3 p-4">
      <AgencyLogo src={agency.logoUrl} name={agency.name} size="sm" />
      <div className="min-w-0">
        <h4 className="break-words font-semibold text-secondary-950">
          <Link href={agencyProfilePath(agency.slug)} color="foreground" underline="hover">
            {agency.name}
          </Link>
        </h4>
        <p className="mt-1 text-sm text-secondary-700">
          <RatingStat rating={agency.rating} reviewCount={agency.reviewCount} locale={locale} /> · {agency.location}
        </p>
      </div>
    </RankingCard>
  );
};
